import { render } from "./Horario_Cita.vue?vue&type=template&id=21aa4f8a"
import script from "./Horario_Cita.vue?vue&type=script&lang=js"
export * from "./Horario_Cita.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__